export default __webpack_public_path__ + "static/media/CNo.90-0.a79bbef4.jpg";